module.exports = __webpack_public_path__ + "static/media/D1-Abzeichen-plus.2df6c765.png";